module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reset-password"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    attrs: {
      "id": "reset-title"
    }
  }, [_vm._v(_vm._s(_vm.$t('resetPassword')))]), _vm._v(" "), _c('div', {
    staticClass: "reset-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('setPassword')))]), _vm._v(" "), (!_vm.isShowPwd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'input pwd': true, 'danger-border': _vm.PwdValidateError
    },
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": _vm.$t('setPassword'),
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "blur": [function($event) {
        _vm.showError.password = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPwd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'input pwd': true, 'danger-border': _vm.PwdValidateError
    },
    attrs: {
      "type": "text",
      "name": "password",
      "id": "password",
      "placeholder": _vm.$t('setPassword'),
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "blur": [function($event) {
        _vm.showError.password = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        _vm.isShowPwd = !_vm.isShowPwd
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd),
      expression: "isShowPwd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd),
      expression: "!isShowPwd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PwdValidateError),
      expression: "PwdValidateError"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group confirm-password-box"
  }, [_c('label', {
    attrs: {
      "for": "confirmPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('confirmPwd')))]), _vm._v(" "), (!_vm.isShowConfirmPWd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirmPwd),
      expression: "confirmPwd",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password|min:6|max:20'),
      expression: "'required|confirmed:password|min:6|max:20'"
    }],
    class: {
      'input pwd': true, 'danger-border': _vm.confirmPwdValidateError
    },
    attrs: {
      "type": "password",
      "name": "confirmPwd",
      "id": "confirmPwd",
      "placeholder": _vm.$t('confirmPwd')
    },
    domProps: {
      "value": (_vm.confirmPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "blur": [function($event) {
        _vm.showError.confirmPwd = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPwd = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowConfirmPWd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirmPwd),
      expression: "confirmPwd",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password|min:6|max:20'),
      expression: "'required|confirmed:password|min:6|max:20'"
    }],
    class: {
      'input pwd': true, 'danger-border': _vm.confirmPwdValidateError
    },
    attrs: {
      "type": "text",
      "name": "confirmPwd",
      "id": "confirmPwd",
      "placeholder": _vm.$t('confirmPwd')
    },
    domProps: {
      "value": (_vm.confirmPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "blur": [function($event) {
        _vm.confirmPwdBlur = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPwd = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        _vm.isShowConfirmPWd = !_vm.isShowConfirmPWd
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowConfirmPWd),
      expression: "isShowConfirmPWd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowConfirmPWd),
      expression: "!isShowConfirmPWd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmPwdValidateError),
      expression: "confirmPwdValidateError"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('confirm')))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "form-submit line-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  })], 1)])]), _vm._v(" "), _c('reset-pwd-success-modal', {
    attrs: {
      "show": _vm.resetPwdSuccess,
      "loginData": _vm.loginData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8c016c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/resetPassword/ResetPassword.vue
// module id = 1384
// module chunks = 1